export default __webpack_public_path__ + "static/media/DOMINGO.4fa11963.jpeg";